<h1>
    <span *ngIf="!zone_id">Add Zone</span>
    <span *ngIf="zone_id">Update Zone</span>
    <button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button>
</h1>
<form [formGroup]="zoneForm" (submit)="createZone()">
    <div class="form-group">
        <div class="row">
            <div class="col-sm-6">
                <label class="form-label">Circle *</label>
                <mat-select placeholder="Select Circle" formControlName="circle_id">
                    <mat-option value="">Select Circle</mat-option>
                    <mat-option [value]="Circle.id" *ngFor="let Circle of circles">{{Circle.name}}</mat-option>
                </mat-select>
                <div *ngIf="submitted && f.circle_id.errors" class="invalid-feedback">
                    <div *ngIf="f.circle_id.errors.required">Circle is required</div>
                </div>
            </div>
            <div class="col-sm-6">
                <label class="form-label">Zone Name *</label>
                <input type="text" formControlName="zone_name" class="form-control" />
                <div *ngIf="submitted && f.zone_name.errors" class="invalid-feedback">
                    <div *ngIf="f.zone_name.errors.required">Zone is required</div>
                </div>
            </div>
        </div>
    </div><br>
    <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
            class="fa fa-spin fa-spinner"></i>
        <span *ngIf="!zone_id">Create Zone</span>
        <span *ngIf="zone_id">Update Zone</span>
    </button>
</form>